import { Resource } from "../resource";


export class EmailSubscription extends Resource {
    email: string
    lang: string
    created: string;

}